import React from "react";
import Select from "react-select";

const StateSelect = ({
  stateList,
  selectedState,
  setSelectedState,
  setFilters,
}) => {
  //   const options = stateList.map((state) => ({
  //     value: state,
  //     label: state,
  //   }));

  const currentUser = JSON.parse(localStorage.getItem("user"));

  const getAssignedStates = () => {
    let states = currentUser?.assigned_state;

    if (!states) return [];

    if (typeof states === "string") {
      try {
        states = JSON.parse(states);
      } catch {
        states = [];
      }
    }

    return Array.isArray(states) ? states.map((s) => s.trim()) : [];
  };

  const assignedStates = getAssignedStates();

  // 🔥 Filter for external users
  let filteredStates =
    currentUser?.type === 1
      ? stateList.filter((state) => assignedStates.includes(state.trim()))
      : stateList;

  const options =
    currentUser?.type === 1
      ? filteredStates.map((state) => ({
          value: state,
          label: state,
        }))
      : [
          { value: "", label: "All States" },
          ...filteredStates.map((state) => ({
            value: state,
            label: state,
          })),
        ];

  const handleChange = (selectedOptions) => {
    let states = selectedOptions || [];
    if (currentUser?.type !== 1 && states.some((s) => s.value === "")) {
      states = [{ value: "", label: "All States" }];
    }
    setSelectedState(states);

    setFilters((prev) => ({
      ...prev,
      State:
        states.length === 1 && states[0].value === ""
          ? ""
          : states.map((s) => s.value).join(","),
    }));
  };

  return (
    <div style={{ width: "200px" }}>
      <Select
        options={options}
        isMulti
        value={selectedState}
        onChange={handleChange}
        placeholder="Select State"
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      />
    </div>
  );
};

export default StateSelect;
